import { ProposalDAOInterface, ProposalTextAreaDAOInterface } from '../ProposalDAO';
import { ProposalDAO } from '../ProposalDAOImpl';
import * as ProposalNS from '../../Proposal';
import * as ProposalElementNS from '../../ProposalElements';
import LocalizedString from '@/types/localized-string';

export default class CommentaryDAO extends ProposalDAO implements ProposalTextAreaDAOInterface {
  public static buildInstance(proposal: ProposalNS.Proposal, proposalElement: ProposalElementNS.ProposalDataElement): ProposalDAOInterface {
    return new CommentaryDAO(proposal, proposalElement);
  }

  key: string | undefined;

  /* eslint-disable-next-line class-methods-use-this */
  protected getColorKeys(): string[] {
    return [];
  }

  /* eslint-disable-next-line class-methods-use-this */
  protected build(): void {
    // test for options
    const daoConfig: ProposalNS.CommentaryConfig = this.proposalElement.DAO as ProposalNS.CommentaryConfig;
    if (daoConfig.commentaryDAOOptions !== undefined) {
      this.key = daoConfig.commentaryDAOOptions.key;
    }
  }

  getTextAreaInitialValue(defaultValue?: LocalizedString): string | undefined {
    if (this.key !== undefined) {
      switch (this.key) {
        case ProposalNS.TEXT_AREA_KEYS.COMMENTARY:
          return this.proposal.comment;
        case ProposalNS.TEXT_AREA_KEYS.ABOUT:
          if (
            this.comments !== undefined &&
            this.comments[this.key] !== undefined &&
            this.comments[this.key][this.locale] !== undefined &&
            this.comments[this.key][this.locale] !== ''
          ) {
            return this.comments[this.key][this.locale];
          }
      }

      const displayValue = defaultValue != null ? this.formatLocalizedString(defaultValue) : undefined;
      if (displayValue !== undefined && displayValue !== '') {
        return displayValue;
      }
    }

    return undefined;
  }
}
